import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FileBrowserSearchComponent } from './file-browser-search/file-browser-search.component';

const routes: Routes = [
    {
        path: 'search',
        component: FileBrowserSearchComponent,
    },
    {
        path: '',
        redirectTo: 'search',
        pathMatch: 'prefix',
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class FileBrowserRoutingModule {}
